<template>
  <div v-if="errors.length" class="error">
    Please correct the following errors:
    <ul>
      <li v-for="(err, index) in errors" :key="index">{{ err }}</li>
    </ul>
  </div>

  <div class="cell small-12">
    <h1>Identity Verification</h1>
    <p>We have retrieved the persons with significant control for your business from Companies House. </p>
    <p>We require a Know Your Customer (KYC) check to be performed on these individuals to meet our anti-money laundering obligations. </p>
    <p>Please provide the email addresses for the persons below, and make them aware that they will be reciving a Trust ID verification request.</p>
  </div>

  <div class="cell small-12">
    <form class="fieldset" @submit.prevent>
      <h2>Persons with Significant Control</h2>
      <br/>
      <PersonEmailInput
        v-for="(contact, idx) in formData.contacts"
        :key="idx"
        :name="`${contact.firstName} ${contact.lastName}`"
        :email="contact.email"
        @update:email="val => contact.email = val"
      />
    </form>
    </div>



</template>


<script setup>

import { ref } from 'vue'
import PersonEmailInput from '@/components/PersonEmailInput.vue';

const errors = ref([])

const props = defineProps({
  formData: Object,
  clientInvite: Object
})

const validateStep = () => {
  errors.value = [];

  for (const contact of props.formData.contacts) {
    const email = contact.email || '';

    if (
      !email ||
      email.length > 256 ||
      !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)
    ) {
      errors.value.push(
        `Please enter a valid email address (maximum 256 characters) for ${contact.firstName} ${contact.lastName}.`
      );
      return false;
    }
  }

  return true;
}
defineExpose({ validateStep });
</script>